import {
  INVESTIGATION_HISTORY_CARD_ROW_HEIGHT_PX,
  INVESTIGATION_HISTORY_PANEL_RECENCY_HEADER_ROW_HEIGHT_PX,
  INVESTIGATION_HISTORY_PANEL_SECTION_GAP_PX,
} from "#src/routes/investigations/history/consts";
import type { InvestigationHistoryListRowType } from "#src/routes/investigations/history/groupInvestigationsByRecency";

/**
 * Returns whether a card row is the last item before the next recency header.
 */
export const isInvestigationHistoryListRowSectionEnd = (
  index: number,
  rows: InvestigationHistoryListRowType[]
): boolean => {
  const row = rows[index];

  if (!row || row.type !== "item") {
    return false;
  }

  return rows[index + 1]?.type === "header";
};

/**
 * Returns whether a history card should show its default bottom divider.
 * Hidden for the last card in a section and the final list card.
 */
export const shouldInvestigationHistoryCardShowBorderBottom = (
  index: number,
  rows: InvestigationHistoryListRowType[]
): boolean => rows[index + 1]?.type === "item";

/**
 * Estimated virtualized row height including section gaps around recency headers.
 */
export const getInvestigationHistoryListRowEstimatedSizePx = (
  index: number,
  rows: InvestigationHistoryListRowType[]
): number => {
  const row = rows[index];

  if (!row) {
    return INVESTIGATION_HISTORY_CARD_ROW_HEIGHT_PX;
  }

  if (row.type === "header") {
    return (
      INVESTIGATION_HISTORY_PANEL_RECENCY_HEADER_ROW_HEIGHT_PX +
      INVESTIGATION_HISTORY_PANEL_SECTION_GAP_PX
    );
  }

  return (
    INVESTIGATION_HISTORY_CARD_ROW_HEIGHT_PX +
    (isInvestigationHistoryListRowSectionEnd(index, rows)
      ? INVESTIGATION_HISTORY_PANEL_SECTION_GAP_PX
      : 0)
  );
};
